var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4859 16.3999C32.7093 16.3999 32.7093 24.5999 27.4859 24.5999C22.2635 24.5999 20.1746 16.3999 14.4285 16.3999C9.72883 16.3999 9.72883 24.5999 14.4285 24.5999C20.1746 24.5999 22.2636 16.3999 27.487 16.3999H27.4859Z",
    stroke: "#131820",
    strokeWidth: 1.88009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z",
    fill: "#131820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinit);
export default __webpack_public_path__ + "static/media/infinit.72fdab84b8103674f6d2dfd7e36390be.svg";
export { ForwardRef as ReactComponent };